import { withInterceptors as rawWithInterceptors } from "@angular/common/http";
import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject, Injector, runInInjectionContext } from "@angular/core";
import { Observable, from } from "rxjs";
import { switchMap } from "rxjs";

export function HttpLazyStandardInterceptors(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const injector = inject(Injector);
  return from(import("./async/interceptors")).pipe(
    switchMap(({ interceptors }) => {
      const chain = interceptors.reduceRight((nextFn, interceptor) => {
        return (request: HttpRequest<unknown>) =>
          runInInjectionContext(injector, () =>
            interceptor(request, (r) => nextFn(r, next)),
          );
      }, next);

      return chain(req, next);
    }),
  );
}

export function withStandardInteceptors() {
  return rawWithInterceptors([HttpLazyStandardInterceptors]);
}
